import { Box, Stack } from '@mui/material'
import { Typography } from 'ComponentLibrary/src/piazza'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { TOOLBAR_HEIGHT } from 'ComponentLibrary/src/molecules/AppBar'
import { EmptyThreadsImage, TinyButton } from 'ComponentLibrary/index'
import { PlusIcon } from '@phosphor-icons/react'

type MessageListEmptyStateProps = {
    isLoading?: boolean
    onNewThreadClick?: () => void
    copy?: Partial<MessageListEmptyStateCopy>
}

export type MessageListEmptyStateCopy = {
    loadingTitle: string
    emptyTitle: string
    emptyDescriptionLineOne: string
    emptyDescriptionLineTwo: string
    newThread: string
}

const DEFAULT_MESSAGE_LIST_EMPTY_STATE_COPY: MessageListEmptyStateCopy = {
    loadingTitle: 'Unterhaltungen werden geladen ...',
    emptyTitle: 'Keine offenen Unterhaltungen vorhanden',
    emptyDescriptionLineOne: 'Starten Sie eine neue Unterhaltung, um Fragen zu stellen, Unterstützung',
    emptyDescriptionLineTwo: 'zu erhalten oder Informationen mit anderen Nutzern auszutauschen.',
    newThread: 'Neue Unterhaltung',
}

export function MessageListEmptyState({ isLoading, onNewThreadClick, copy }: MessageListEmptyStateProps) {
    const resolvedCopy = { ...DEFAULT_MESSAGE_LIST_EMPTY_STATE_COPY, ...copy }
    return (
        <Stack
            direction="column"
            bgcolor={tokens.ColorBackgroundDark}
            alignItems="center"
            justifyContent="center"
            height={`calc(100vh - ${TOOLBAR_HEIGHT}) - ${tokens.SizingSpacing025}`}
            width="100%"
        >
            <Stack direction="column" alignItems="center">
                <EmptyThreadsImage height="270px" width="270px" />
                <Stack direction="column" alignItems="center" gap={tokens.SizingSpacing200}>
                    <Typography variant="headline3" color={tokens.ColorTextBoldest}>
                        {isLoading ? resolvedCopy.loadingTitle : resolvedCopy.emptyTitle}
                    </Typography>
                    {!isLoading && (
                        <Stack direction="column" alignItems="center">
                            <Typography variant="textS" color={tokens.ColorTextDefault}>
                                {resolvedCopy.emptyDescriptionLineOne}
                            </Typography>
                            <Typography variant="textS" color={tokens.ColorTextDefault}>
                                {resolvedCopy.emptyDescriptionLineTwo}
                            </Typography>
                        </Stack>
                    )}
                    {!isLoading && onNewThreadClick ? (
                        <TinyButton leftIcon={<PlusIcon />} label={resolvedCopy.newThread} onClick={onNewThreadClick} />
                    ) : (
                        <Box height="32px" />
                    )}
                </Stack>
            </Stack>
        </Stack>
    )
}
